import { useState } from 'react';

import Layout from '@/modules/core/components/Layout';

/* const fetchTMM = async () => {
  const response = await fetch('https://atb.tn/tmm.php');
  const text = await response.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const tmmValueElement = doc.querySelector('#tmmValue');
  // @ts-ignore
  const tmmValue = tmmValueElement ? parseFloat(tmmValueElement.value) : 7.97;

  return tmmValue;
}; */

const Simulator = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [creditType, setCreditType] = useState('');
  const [email, setEmail] = useState('');
  const [pays, setPays] = useState('');
  const [ville, setVille] = useState('');
  const [profession, setProfession] = useState('');
  const [banque, setBanque] = useState('');
  const [amount, setAmount] = useState(0);
  const [duration, setDuration] = useState(10);
  const [rate, setRate] = useState(0);
  const [monthlyPayment, setMonthlyPayment] = useState<number | null>(null);
  const [tmm] = useState(7.97);
  const [isLoading, setIsLoading] = useState(false);

  const handleSimulation = async () => {
    setIsLoading(true);

    let annualRate = 0;

    if (duration <= 7) {
      annualRate = tmm + 2.2;
    } else if (duration <= 15) {
      annualRate = tmm + 2.5;
    } else if (duration <= 20) {
      annualRate = tmm + 3.0;
    }

    const commission = (amount * 0.75) / 100;
    const amountWithRate = (amount * annualRate) / 100;
    const totalAmount = amount + commission + amountWithRate;
    const monthlyP = totalAmount / (duration * 12);

    setRate(annualRate);
    setMonthlyPayment(monthlyP);

    await fetch('/api/simulator', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fileId: '1cPXWC-fjaXD9PQ1jrjMewVE7fr36juVSTcF0XBR8Jns',
        columns: [
          name,
          phone,
          email,
          pays,
          ville,
          profession,
          banque,
          creditType,
          amount,
          duration,
          annualRate,
          monthlyP?.toFixed(2),
        ],
      }),
    });

    setIsLoading(false);
    setTimeout(() => {
      window.scrollBy({ top: 150, behavior: 'smooth' });
    }, 100);
  };

  const isFormValid = () =>
    name.trim() !== '' &&
    phone !== '+216' &&
    phone.trim() !== '' &&
    creditType !== '' &&
    amount > 0;

  const formatNumber = (num: number) =>
    new Intl.NumberFormat('fr-TN').format(num);

  return (
    <div className="w-full lg:mt-0 mt-10 mb-20 lg:mb-40 pt-4 pb-10 px-4 ">
      <div className="w-full mx-auto max-w-6xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl lg:text-5xl font-black text-primary leading-tight mb-4">
            Simulez votre crédit
          </h1>
          <p className="text-neutral-600 text-base lg:text-lg">
            Calculez votre mensualité en quelques clics
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-neutral-200">
          <div className="p-6 lg:p-10">
            <div className="space-y-8">
              <div>
                <h2 className="text-xl lg:text-2xl font-bold text-neutral-800 mb-6 pb-3 border-b-2 border-neutral-200">
                  Informations personnelles
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Nom et Prénom <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="Entrez votre nom complet"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Numéro de téléphone{' '}
                      <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="+216 XX XXX XXX"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Email
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="votre.email@exemple.com"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Pays de résidence
                    </label>
                    <input
                      type="text"
                      value={pays}
                      onChange={(e) => setPays(e.target.value)}
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="Tunisie"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Ville
                    </label>
                    <input
                      type="text"
                      value={ville}
                      onChange={(e) => setVille(e.target.value)}
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="Tunis"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Profession
                    </label>
                    <input
                      type="text"
                      value={profession}
                      onChange={(e) => setProfession(e.target.value)}
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="Votre profession"
                    />
                  </div>

                  <div className="space-y-2 md:col-span-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Banque
                    </label>
                    <input
                      type="text"
                      value={banque}
                      onChange={(e) => setBanque(e.target.value)}
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="Nom de votre banque"
                    />
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-xl lg:text-2xl font-bold text-neutral-800 mb-6 pb-3 border-b-2 border-neutral-200">
                  Détails du crédit
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Type de crédit <span className="text-red-600">*</span>
                    </label>
                    <div className="relative">
                      <select
                        value={creditType}
                        onChange={(e) => setCreditType(e.target.value)}
                        className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400 bg-white appearance-none cursor-pointer pr-10"
                      >
                        <option value="">Sélectionnez un type</option>
                        <option value="terrain">Acquisition Terrain</option>
                        <option value="logement-neuf">
                          Acquisition Logement Neuf
                        </option>
                        <option value="logement-ancien">
                          Acquisition Logement Ancien
                        </option>
                        <option value="construction">Construction</option>
                        <option value="renovation">Rénovation</option>
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-neutral-500">
                        <svg
                          className="h-5 w-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Montant (DT) <span className="text-red-600">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        value={amount || ''}
                        onChange={(e) =>
                          setAmount(parseFloat(e.target.value) || 0)
                        }
                        className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400 pr-12"
                        placeholder="50000"
                        min="0"
                        step="1000"
                      />
                      <span className="absolute right-4 top-3.5 text-neutral-500 font-medium">
                        DT
                      </span>
                    </div>
                    {amount > 0 && (
                      <p className="text-sm text-neutral-600">
                        {formatNumber(amount)} DT
                      </p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                      Durée de remboursement (ans)
                    </label>
                    <input
                      type="number"
                      value={duration}
                      onChange={(e) =>
                        setDuration(parseInt(e.target.value, 10))
                      }
                      min={1}
                      max={20}
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="10"
                    />
                  </div>
                </div>
              </div>

              <div className="pt-4">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleSimulation();
                  }}
                  disabled={!isFormValid() || isLoading}
                  className={`w-full py-4 rounded-xl font-semibold text-base lg:text-lg transition-all duration-300 transform ${
                    isFormValid() && !isLoading
                      ? 'bg-secondary hover:to-pritext-primary text-white shadow-lg hover:shadow-xl hover:scale-[0.99]'
                      : 'bg-neutral-200 text-neutral-400 cursor-not-allowed'
                  }`}
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center gap-3">
                      <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                          fill="none"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      Calcul en cours...
                    </span>
                  ) : (
                    'Simuler mon crédit'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {monthlyPayment !== null && (
          <div className="mt-8">
            <div className=" border-2 border-green-200 rounded-2xl p-8 shadow-lg">
              <h2 className="text-2xl lg:text-3xl font-black text-green-800 mb-6 text-center">
                Résultat de Simulation
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-xl shadow-md text-center border border-green-100">
                  <p className="text-sm text-neutral-600 mb-2 font-medium">
                    Montant à emprunter
                  </p>
                  <p className="text-2xl lg:text-3xl font-bold text-neutral-800">
                    {formatNumber(amount)} DT
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-md text-center border border-green-100">
                  <p className="text-sm text-neutral-600 mb-2 font-medium">
                    Taux annuel
                  </p>
                  <p className="text-2xl lg:text-3xl font-bold text-red-700">
                    {rate.toFixed(2)}%
                  </p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-md text-center border-2 border-green-300">
                  <p className="text-sm text-neutral-600 mb-2 font-medium">
                    Mensualité
                  </p>
                  <p className="text-2xl lg:text-3xl font-bold text-green-700">
                    {formatNumber(parseFloat(monthlyPayment.toFixed(2)))} DT
                  </p>
                </div>
              </div>
              <p className="text-center text-sm text-neutral-800 mt-6">
                Sur une durée de {duration} ans ({duration * 12} mois)
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Simulator.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};

export default Simulator;
